// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* TextArea Component Styles */

:root {
  --scl--cms-components-textArea-border-color: var(--input-defualt);
  --scl--cms-components-textArea-border-hover-color: var(--input-hover);
  --scl--cms-components-textArea-focus-color: #2388FF;
  --scl--cms-components-textArea-warning-color: #FFC18E;
  --scl--cms-components-textArea-error-color: #F8868A;
  --scl--cms-components-textArea-text-color: var(--input-hover);
  --scl--cms-components-textArea-label-color: var(--input-defualt);
  --scl--cms-components-textArea-label-hover-color: var(--input-hover);
  --scl--cms-components-textArea-label-floating-bg: linear-gradient(108.2deg, #E9F0F8 0%, #FAFBFC 41.13%, #E9F0F8 96.11%);
  --scl--cms-components-textArea-required-color: #EB5252;
  --scl--cms-components-textArea-assistive-text-color: rgba(255, 255, 255, 0.54);
  --scl--cms-components-textArea-assistive-error-color: #FF5252;
  --scl--cms-components-textArea-assistive-warning-color: #FFC18E;
  --scl--cms-components-textArea-char-count-color: var(--input-defualt);
}

/* Container */
.scl--cms-components-textArea-container {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding: 0px;
  width: 100%;
  flex: none;
  order: 0;
  align-self: stretch;
  flex-grow: 0;
  position: relative;
}

/* Plate — min-height driven by inline style from rows/height calculation */
.scl--cms-components-textArea-plate {
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  width: 100%;
  border: 1px solid var(--scl--cms-components-textArea-border-color);
  border-radius: 3px;
  cursor: text;
  transition: border-color 0.3s ease;
  position: relative;
  flex: none;
  order: 0;
  align-self: stretch;
  flex-grow: 0;
  background: transparent;
}

/* Bottom accent bar */
.scl--cms-components-textArea-plate::after {
  content: '';
  position: absolute;
  left: -1px;
  bottom: -1px;
  width: calc(100% + 2px);
  height: 4px;
  border-bottom-left-radius: 3px;
  border-bottom-right-radius: 3px;
  background: var(--scl--cms-components-textArea-focus-color);
  opacity: 0;
  transition: opacity 0.3s ease;
  pointer-events: none;
}

.scl--cms-components-textArea-plate.scl--cms-components-textArea--focused::after {
  opacity: 1;
}

.scl--cms-components-textArea-plate:hover:not(.scl--cms-components-textArea--focused) {
  border-color: var(--scl--cms-components-textArea-border-hover-color);
}

.scl--cms-components-textArea-plate.scl--cms-components-textArea--focused {
  border-color: var(--scl--cms-components-textArea-border-hover-color);
}

.scl--cms-components-textArea-plate.scl--cms-components-textArea--warning::after {
  background: var(--scl--cms-components-textArea-warning-color);
  opacity: 1;
}

.scl--cms-components-textArea-plate.scl--cms-components-textArea--error::after {
  background: var(--scl--cms-components-textArea-error-color);
  opacity: 1;
}

.scl--cms-components-textArea-plate.scl--cms-components-textArea--disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

/* Inner wrapper */
.scl--cms-components-textArea-wrapper {
  display: flex;
  flex-direction: column;
  padding: 10px 12px 8px 12px;
  width: 100%;
  box-sizing: border-box;
  flex: 1;
  flex-grow: 1;
}

/* Textarea — height set via inline style, no resize, no scrollbar */
.scl--cms-components-textArea-input {
  width: 100%;
  background: transparent;
  border: none;
  outline: none;
  font-family: var(--scl--default-font);
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 22px;
  letter-spacing: 0.25px;
  caret-color: var(--input-hover);
  color: var(--scl--cms-components-textArea-text-color);
  padding: 0;
  box-sizing: border-box;

  /* ✅ No resize, no scrollbar — height managed entirely by prop */
  resize: none;
  overflow: hidden;
}

.scl--cms-components-textArea-input::placeholder {
  color: transparent;
}

.scl--cms-components-textArea-input:disabled {
  cursor: not-allowed;
}

/* Floating Label */
.scl--cms-components-textArea-label {
  position: absolute;
  left: 12px;
  top: 18px;
  transform: translateY(-50%);
  font-family: var(--scl--default-font);
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
  line-height: 20px;
  letter-spacing: 0.25px;
  color: var(--scl--cms-components-textArea-label-color);
  background: transparent;
  padding: 0 2px;
  margin: 0 -2px;
  pointer-events: none;
  transition: all 0.2s ease;
  z-index: 1;
  opacity: 1;
}

/* Floating state */
.scl--cms-components-textArea-label.scl--cms-components-textArea-label--floating {
  top: 0;
  left: 12px;
  transform: translateY(-50%);
  font-size: 12px;
  line-height: 16px;
  background: var(--neutralcolors-100);
  color: var(--typography-text-body-secondary);
  padding: 0 6px;
  margin: 0 -6px;
}

/* Hover label */
.scl--cms-components-textArea-plate:hover:not(.scl--cms-components-textArea--focused) .scl--cms-components-textArea-label {
  color: var(--typography-text-body-secondary);
}

/* Required asterisk */
.scl--cms-components-textArea-requiredAsterisk {
  color: var(--scl--cms-components-textArea-required-color);
}

/* Character count footer */
.scl--cms-components-textArea-footer {
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  align-items: center;
  padding: 0 12px 6px 12px;
  width: 100%;
  box-sizing: border-box;
}

.scl--cms-components-textArea-charCount {
  font-family: var(--scl--default-font);
  font-style: normal;
  font-weight: 400;
  font-size: 11px;
  line-height: 14px;
  letter-spacing: 0.2px;
  color: var(--scl--cms-components-textArea-char-count-color);
  transition: color 0.2s ease;
}

.scl--cms-components-textArea-charCount.scl--cms-components-textArea-charCount--limit {
  color: var(--scl--cms-components-textArea-assistive-error-color);
}

/* Assistive / Error / Warning text */
.scl--cms-components-textArea-assistive {
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 4px 4px 0px 14px;
  min-height: 16px;
  font-family: var(--scl--default-font);
  font-style: normal;
  font-weight: 400;
  font-size: 12px;
  line-height: 12px;
  letter-spacing: -0.15px;
  color: var(--scl--cms-components-textArea-assistive-text-color);
  width: 100%;
  box-sizing: border-box;
}

.scl--cms-components-textArea-assistive.scl--cms-components-textArea-assistive--error {
  color: var(--scl--cms-components-textArea-assistive-error-color);
}

.scl--cms-components-textArea-assistive.scl--cms-components-textArea-assistive--warning {
  color: var(--scl--cms-components-textArea-assistive-warning-color);
}`, "",{"version":3,"sources":["webpack://./src/component-controller-mod/component-serv/input-fs-cp/textarea-field-op/css/textArea.css"],"names":[],"mappings":"AAAA,8BAA8B;;AAE9B;EACE,iEAAiE;EACjE,qEAAqE;EACrE,mDAAmD;EACnD,qDAAqD;EACrD,mDAAmD;EACnD,6DAA6D;EAC7D,gEAAgE;EAChE,oEAAoE;EACpE,uHAAuH;EACvH,sDAAsD;EACtD,8EAA8E;EAC9E,6DAA6D;EAC7D,+DAA+D;EAC/D,qEAAqE;AACvE;;AAEA,cAAc;AACd;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,YAAY;EACZ,WAAW;EACX,UAAU;EACV,QAAQ;EACR,mBAAmB;EACnB,YAAY;EACZ,kBAAkB;AACpB;;AAEA,2EAA2E;AAC3E;EACE,sBAAsB;EACtB,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,WAAW;EACX,kEAAkE;EAClE,kBAAkB;EAClB,YAAY;EACZ,kCAAkC;EAClC,kBAAkB;EAClB,UAAU;EACV,QAAQ;EACR,mBAAmB;EACnB,YAAY;EACZ,uBAAuB;AACzB;;AAEA,sBAAsB;AACtB;EACE,WAAW;EACX,kBAAkB;EAClB,UAAU;EACV,YAAY;EACZ,uBAAuB;EACvB,WAAW;EACX,8BAA8B;EAC9B,+BAA+B;EAC/B,2DAA2D;EAC3D,UAAU;EACV,6BAA6B;EAC7B,oBAAoB;AACtB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,oEAAoE;AACtE;;AAEA;EACE,oEAAoE;AACtE;;AAEA;EACE,6DAA6D;EAC7D,UAAU;AACZ;;AAEA;EACE,2DAA2D;EAC3D,UAAU;AACZ;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA,kBAAkB;AAClB;EACE,aAAa;EACb,sBAAsB;EACtB,2BAA2B;EAC3B,WAAW;EACX,sBAAsB;EACtB,OAAO;EACP,YAAY;AACd;;AAEA,oEAAoE;AACpE;EACE,WAAW;EACX,uBAAuB;EACvB,YAAY;EACZ,aAAa;EACb,qCAAqC;EACrC,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,sBAAsB;EACtB,+BAA+B;EAC/B,qDAAqD;EACrD,UAAU;EACV,sBAAsB;;EAEtB,gEAAgE;EAChE,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA,mBAAmB;AACnB;EACE,kBAAkB;EAClB,UAAU;EACV,SAAS;EACT,2BAA2B;EAC3B,qCAAqC;EACrC,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,sBAAsB;EACtB,sDAAsD;EACtD,uBAAuB;EACvB,cAAc;EACd,cAAc;EACd,oBAAoB;EACpB,yBAAyB;EACzB,UAAU;EACV,UAAU;AACZ;;AAEA,mBAAmB;AACnB;EACE,MAAM;EACN,UAAU;EACV,2BAA2B;EAC3B,eAAe;EACf,iBAAiB;EACjB,oCAAoC;EACpC,4CAA4C;EAC5C,cAAc;EACd,cAAc;AAChB;;AAEA,gBAAgB;AAChB;EACE,4CAA4C;AAC9C;;AAEA,sBAAsB;AACtB;EACE,yDAAyD;AAC3D;;AAEA,2BAA2B;AAC3B;EACE,aAAa;EACb,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,wBAAwB;EACxB,WAAW;EACX,sBAAsB;AACxB;;AAEA;EACE,qCAAqC;EACrC,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,qBAAqB;EACrB,2DAA2D;EAC3D,2BAA2B;AAC7B;;AAEA;EACE,gEAAgE;AAClE;;AAEA,qCAAqC;AACrC;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,yBAAyB;EACzB,gBAAgB;EAChB,qCAAqC;EACrC,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,uBAAuB;EACvB,+DAA+D;EAC/D,WAAW;EACX,sBAAsB;AACxB;;AAEA;EACE,gEAAgE;AAClE;;AAEA;EACE,kEAAkE;AACpE","sourcesContent":["/* TextArea Component Styles */\n\n:root {\n  --scl--cms-components-textArea-border-color: var(--input-defualt);\n  --scl--cms-components-textArea-border-hover-color: var(--input-hover);\n  --scl--cms-components-textArea-focus-color: #2388FF;\n  --scl--cms-components-textArea-warning-color: #FFC18E;\n  --scl--cms-components-textArea-error-color: #F8868A;\n  --scl--cms-components-textArea-text-color: var(--input-hover);\n  --scl--cms-components-textArea-label-color: var(--input-defualt);\n  --scl--cms-components-textArea-label-hover-color: var(--input-hover);\n  --scl--cms-components-textArea-label-floating-bg: linear-gradient(108.2deg, #E9F0F8 0%, #FAFBFC 41.13%, #E9F0F8 96.11%);\n  --scl--cms-components-textArea-required-color: #EB5252;\n  --scl--cms-components-textArea-assistive-text-color: rgba(255, 255, 255, 0.54);\n  --scl--cms-components-textArea-assistive-error-color: #FF5252;\n  --scl--cms-components-textArea-assistive-warning-color: #FFC18E;\n  --scl--cms-components-textArea-char-count-color: var(--input-defualt);\n}\n\n/* Container */\n.scl--cms-components-textArea-container {\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  padding: 0px;\n  width: 100%;\n  flex: none;\n  order: 0;\n  align-self: stretch;\n  flex-grow: 0;\n  position: relative;\n}\n\n/* Plate — min-height driven by inline style from rows/height calculation */\n.scl--cms-components-textArea-plate {\n  box-sizing: border-box;\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  width: 100%;\n  border: 1px solid var(--scl--cms-components-textArea-border-color);\n  border-radius: 3px;\n  cursor: text;\n  transition: border-color 0.3s ease;\n  position: relative;\n  flex: none;\n  order: 0;\n  align-self: stretch;\n  flex-grow: 0;\n  background: transparent;\n}\n\n/* Bottom accent bar */\n.scl--cms-components-textArea-plate::after {\n  content: '';\n  position: absolute;\n  left: -1px;\n  bottom: -1px;\n  width: calc(100% + 2px);\n  height: 4px;\n  border-bottom-left-radius: 3px;\n  border-bottom-right-radius: 3px;\n  background: var(--scl--cms-components-textArea-focus-color);\n  opacity: 0;\n  transition: opacity 0.3s ease;\n  pointer-events: none;\n}\n\n.scl--cms-components-textArea-plate.scl--cms-components-textArea--focused::after {\n  opacity: 1;\n}\n\n.scl--cms-components-textArea-plate:hover:not(.scl--cms-components-textArea--focused) {\n  border-color: var(--scl--cms-components-textArea-border-hover-color);\n}\n\n.scl--cms-components-textArea-plate.scl--cms-components-textArea--focused {\n  border-color: var(--scl--cms-components-textArea-border-hover-color);\n}\n\n.scl--cms-components-textArea-plate.scl--cms-components-textArea--warning::after {\n  background: var(--scl--cms-components-textArea-warning-color);\n  opacity: 1;\n}\n\n.scl--cms-components-textArea-plate.scl--cms-components-textArea--error::after {\n  background: var(--scl--cms-components-textArea-error-color);\n  opacity: 1;\n}\n\n.scl--cms-components-textArea-plate.scl--cms-components-textArea--disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n}\n\n/* Inner wrapper */\n.scl--cms-components-textArea-wrapper {\n  display: flex;\n  flex-direction: column;\n  padding: 10px 12px 8px 12px;\n  width: 100%;\n  box-sizing: border-box;\n  flex: 1;\n  flex-grow: 1;\n}\n\n/* Textarea — height set via inline style, no resize, no scrollbar */\n.scl--cms-components-textArea-input {\n  width: 100%;\n  background: transparent;\n  border: none;\n  outline: none;\n  font-family: var(--scl--default-font);\n  font-style: normal;\n  font-weight: 400;\n  font-size: 14px;\n  line-height: 22px;\n  letter-spacing: 0.25px;\n  caret-color: var(--input-hover);\n  color: var(--scl--cms-components-textArea-text-color);\n  padding: 0;\n  box-sizing: border-box;\n\n  /* ✅ No resize, no scrollbar — height managed entirely by prop */\n  resize: none;\n  overflow: hidden;\n}\n\n.scl--cms-components-textArea-input::placeholder {\n  color: transparent;\n}\n\n.scl--cms-components-textArea-input:disabled {\n  cursor: not-allowed;\n}\n\n/* Floating Label */\n.scl--cms-components-textArea-label {\n  position: absolute;\n  left: 12px;\n  top: 18px;\n  transform: translateY(-50%);\n  font-family: var(--scl--default-font);\n  font-style: normal;\n  font-weight: 400;\n  font-size: 16px;\n  line-height: 20px;\n  letter-spacing: 0.25px;\n  color: var(--scl--cms-components-textArea-label-color);\n  background: transparent;\n  padding: 0 2px;\n  margin: 0 -2px;\n  pointer-events: none;\n  transition: all 0.2s ease;\n  z-index: 1;\n  opacity: 1;\n}\n\n/* Floating state */\n.scl--cms-components-textArea-label.scl--cms-components-textArea-label--floating {\n  top: 0;\n  left: 12px;\n  transform: translateY(-50%);\n  font-size: 12px;\n  line-height: 16px;\n  background: var(--neutralcolors-100);\n  color: var(--typography-text-body-secondary);\n  padding: 0 6px;\n  margin: 0 -6px;\n}\n\n/* Hover label */\n.scl--cms-components-textArea-plate:hover:not(.scl--cms-components-textArea--focused) .scl--cms-components-textArea-label {\n  color: var(--typography-text-body-secondary);\n}\n\n/* Required asterisk */\n.scl--cms-components-textArea-requiredAsterisk {\n  color: var(--scl--cms-components-textArea-required-color);\n}\n\n/* Character count footer */\n.scl--cms-components-textArea-footer {\n  display: flex;\n  flex-direction: row;\n  justify-content: flex-end;\n  align-items: center;\n  padding: 0 12px 6px 12px;\n  width: 100%;\n  box-sizing: border-box;\n}\n\n.scl--cms-components-textArea-charCount {\n  font-family: var(--scl--default-font);\n  font-style: normal;\n  font-weight: 400;\n  font-size: 11px;\n  line-height: 14px;\n  letter-spacing: 0.2px;\n  color: var(--scl--cms-components-textArea-char-count-color);\n  transition: color 0.2s ease;\n}\n\n.scl--cms-components-textArea-charCount.scl--cms-components-textArea-charCount--limit {\n  color: var(--scl--cms-components-textArea-assistive-error-color);\n}\n\n/* Assistive / Error / Warning text */\n.scl--cms-components-textArea-assistive {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  padding: 4px 4px 0px 14px;\n  min-height: 16px;\n  font-family: var(--scl--default-font);\n  font-style: normal;\n  font-weight: 400;\n  font-size: 12px;\n  line-height: 12px;\n  letter-spacing: -0.15px;\n  color: var(--scl--cms-components-textArea-assistive-text-color);\n  width: 100%;\n  box-sizing: border-box;\n}\n\n.scl--cms-components-textArea-assistive.scl--cms-components-textArea-assistive--error {\n  color: var(--scl--cms-components-textArea-assistive-error-color);\n}\n\n.scl--cms-components-textArea-assistive.scl--cms-components-textArea-assistive--warning {\n  color: var(--scl--cms-components-textArea-assistive-warning-color);\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
